import { createContext } from 'react';
var DialogBackdropContext = /*#__PURE__*/createContext(undefined);
export { DialogBackdropContext as D };